import React from "react";

const PropertyIcon = ({ color = "#424242", ...props }) => (
  <svg width={42} height={31} viewBox="0 0 42 31" {...props}>
    <path
      fill={color}
      d="M28.647 30.082a.945.945 0 0 1-.117.008H.932A.93.93 0 0 1 0 29.16V11.33c0-.29.137-.565.37-.74L14.169.187a.935.935 0 0 1 1.125 0l2.486 1.874L20.29.188c.337-.25.8-.25 1.137 0l2.538 1.895L26.51.188a.957.957 0 0 1 1.14 0L41.626 10.59c.235.176.374.45.374.741v17.83a.937.937 0 0 1-.944.93h-6.043a.97.97 0 0 1-.112-.007.964.964 0 0 1-.111.007h-6.024a.963.963 0 0 1-.119-.008zm.816-1.85h4.386v-16.44l-12.99-9.699-1.526 1.14 9.76 7.356c.233.176.37.45.37.741v16.902zm6.268 0h4.38v-16.44l-13.03-9.699-1.554 1.157 9.831 7.34c.235.175.373.45.373.74v16.902zm-24.916 0v-8.73a.93.93 0 0 1 .933-.928h5.967a.93.93 0 0 1 .932.928v8.73h8.951v-16.44L14.731 2.093 1.865 11.792v16.44h8.95zm1.865-7.8v7.8h4.103v-7.8H12.68z"
    />
  </svg>
);

export default PropertyIcon;
